<template>
<div class="settings">
    <div class="columns">
        <div class="column is-one-quarter">
            <div class="columns">
                <div class="column is-11">
                    <settings-menu active-item="subscription"></settings-menu>
                </div>
            </div>
        </div>
        <div class="column">
            <div class="settings-container">
                <div class="columns">
                    <div v-if="loading" class="column is-full has-text-centered">
                        <img src="/loader-dark.svg">
                    </div>
                    <div v-if="!loading && loadedOnce" class="column is-full">
                        <div class="columns is-multiline">
                            <div v-if="successMessage || showInTrialInfo || showTrialExpiredInfo || showPastDueWarning || showSubscriptionCancelled || showSubscriptionCancelledAndEffective" class="column is-full">
                                <div v-if="showSuccessMessage" class="notification is-success" style="font-size: 13px;">
                                    {{ successMessage }}
                                </div>
                                <div v-if="showInTrialInfo" class="notification is-info" style="font-size: 13px;">
                                    Your free trial is still active until <strong>{{ formatDate(user.trial_expires_at) }} UTC</strong>. If you don't subscribe to a plan before the trial expires, Weap.io will stop taking care of your backups.
                                </div>
                                <div v-if="showTrialExpiredInfo" class="notification is-info" style="font-size: 13px;">
                                    Your free trial expired and Weap.io is not taking care of your backups anymore. Subscribe to a plan if you want to use Weap.io further.
                                </div>
                                <div v-if="showPastDueWarning" class="notification is-danger" style="font-size: 13px;">
                                    Your Weap.io subscription is past due. Make sure your account has enough funds when we will attempt again. Your subscription will be cancelled after 3 unsuccessful attempts.
                                    Update your card <strong><a href="#">here</a></strong>.
                                </div>
                                <div v-if="showSubscriptionCancelled" class="notification is-danger" style="font-size: 13px;">
                                    Your Weap.io subscription was cancelled. Starting from <strong>{{ user.subscription_cancellation_effective_from }}</strong>, Weap.io will stop taking care of your backups.
                                </div>
                                <div v-if="showSubscriptionCancelledAndEffective" class="notification is-danger" style="font-size: 13px;">
                                    Your subscription was cancelled and Weap.io is not taking care of your backups anymore. Subscribe to a plan if you want to use Weap.io again.
                                </div>
                            </div>
                            <div class="column is-3">
                                <div class="plan-page-label">Plan</div>
                                <div class="plan-page-description" style="font-size:13px !important;">
                                    Choose a plan that fits your needs based on quantity. We don't limit the features.
                                    <p v-if="user.subscription_active">
                                        <br>
                                        <strong><a @click="openUpdate">Click here</a></strong> if you want to update your payment details, <strong><a @click="openCancel">or here</a></strong> if you want to cancel your subscription.
                                    </p>
                                </div>
                            </div>
                            <div class="column is-9" style="padding-left: 60px;">
                                <div class="columns is-multiline">
                                    <div v-for="plan in plans" @click="handlePlan(plan)" class="column is-half">
                                        <div class="plan provider-box" style="border-radius:6px !important;" :class="{ 'cursor-not-allowed': isActivePlan(plan) }">
                                            <div class="plan-details">
                                                <!-- <div class="columns">

                                                </div> -->
                                                <div class="columns is-multiline">
                                                    <div class="column is-half" style="padding-bottom:0;">
                                                        <div class="plan-title">{{ plan.name }}</div>
                                                    </div>
                                                    <div class="column is-half has-text-right" style="padding-bottom:0;">
                                                        <span v-if="isActivePlan(plan)" class="tag is-success is-small">Active</span>
                                                    </div>
                                                    <div class="column is-half">
                                                        <div class="plan-price">
                                                            <span class="plan-amount">€{{ plan.amount }}</span><span class="plan-period">/month</span>
                                                        </div>
                                                    </div>
                                                    <div class="column is-half has-text-right">
                                                        <div class="plan-quantity">
                                                            <span class="plan-quantity">{{ plan.quantity }}</span><span class="plan-resource"> cloudlets</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<style>
.plan-page-label {
    font-size: 14px;
    font-weight: 500;
    color: #6c757d;
}
.plan-page-description {
    margin-top: 10px;
    font-size: 14px;
    color: #999;
}
.plan-title {
    color: #4dabf7;
    font-weight: 500;
}
.plan-icon {
    display: inline-block;
}
.plan-details {
    vertical-align: top;
    display: inline-block;
    width: 100%;
}
.plan-period, .plan-resource {
    color: #999;
    font-size: 13px;
}

.plan-quantity {
    display: inline-block;
}

.plan-price {
    display: inline-block;
}

</style>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';
import FormErrorsMixin from '@/mixins/FormErrors';

import SettingsMenu from '@/components/Settings/Menu.vue';

export default {
    components: {
        SettingsMenu,
    },

    mixins: [FormErrorsMixin],

    metaInfo: {
        title: 'Subscription - Weap.io',
    },

    data() {
        return {
            loading: false,
            loadedOnce: false,
            user: null,
            successMessage: null,
            plans: [
                {
                    name: 'Starter',
                    id: 575023,
                    amount: 7,
                    quantity: 10,
                },
                {
                    name: 'Standard',
                    id: 575449,
                    amount: 25,
                    quantity: 50,
                },
                {
                    name: 'Pro',
                    id: 575450,
                    amount: 75,
                    quantity: 500,
                },
            ],
        }
    },

    mounted() {
        this.initPaddle();
        this.getUser();
    },

    methods: {
        initPaddle(timeout) {
            this.loading = true;
            this.loadedOnce = true;

            let paddleScript = document.createElement('script');
            paddleScript.setAttribute('src', 'https://cdn.paddle.com/paddle/paddle.js');

            document.head.appendChild(paddleScript);

            let vm = this;

            function setupPaddle() {
                if (typeof Paddle == 'undefined') {
                    setTimeout(setupPaddle, 2000);
                } else {
                    Paddle.Setup({ vendor: 103944 });
                    vm.loading = false;
                }
            }

            setTimeout(setupPaddle, 2000);
        },

        handlePlan(plan) {
            if (!this.hasActivePlan) {
                this.openCheckout(plan);
            } else {
                this.updatePlan(plan);
            }
        },

        openCheckout(plan) {
            if (this.isActivePlan(plan)) {
                return;
            }

            Paddle.Checkout.open({
                product: plan.id,
                email: localStorage.email,
                passthrough: JSON.stringify({
                    snapshotly_user_id: localStorage.userId
                }),
                successCallback: (data) => {
                    if (typeof data.checkout !== 'undefined' && data.checkout.completed == true) {
                        this.loading = true;
                        setTimeout(() => {
                            this.getUser(() => {
                                if (this.user.subscription_active) {
                                    this.loading = false;
                                    this.successMessage = 'You have been successfully subscribed to the selected plan.'
                                } else {
                                    setTimeout(() => {
                                        this.getUser(() => {
                                            this.loading = false;
                                            this.successMessage = 'You have been successfully subscribed to the selected plan.'
                                        });
                                    }, 5000);
                                }
                            });
                        }, 5000);
                        return;
                    }
                },
            });
        },

        openCancel() {
            Paddle.Checkout.open({
                override: this.user.subscription_cancel_url,
                successCallback: (data) => {
                    if (typeof data.checkout !== 'undefined' && data.checkout.completed == true) {
                        this.loading = true;
                        setTimeout(() => {
                            this.getUser(() => {
                                if (this.user.subscription_active) {
                                    this.loading = false;
                                } else {
                                    setTimeout(() => {
                                        this.getUser(() => {
                                            this.loading = false;
                                        });
                                    }, 5000);
                                }
                            });
                        }, 5000);
                        return;
                    }
                },
            });
        },

        openUpdate() {
            Paddle.Checkout.open({
                override: this.user.subscription_update_url,
            });
        },

        updatePlan(plan) {
            if (this.loading) {
                return;
            }

            this.loading = true;
            let endpoint = 'users/current/subscription/plan/' + plan.id;
            Api().put(endpoint)
                .then((response) => {
                    setTimeout(() => {
                        this.getUser(() => {
                            this.loading = false;
                            this.successMessage = 'Your subscription plan has been updated.';
                        });
                    }, 8000);
                })
                .catch((error) => {
                    this.loading = false;
                    // TODO handle error case
                })
                .finally(() => {
                    //
                });
        },

        getUser(finallyCallback) {
            Api().get('users/current')
                .then((response) => {
                    this.user = response.data.data;
                })
                .catch((error) => {
                    //
                })
                .finally(() => {
                    if (typeof finallyCallback == 'function') {
                        finallyCallback();
                    }
                });
        },

        isActivePlan(plan) {
            if (this.user.active_plan_paddle_id == plan.id) {
                return true;
            }

            return false;
        },

        formatDate(dateTime) {
            return dateTime.slice(0, -3);
        },
    },

    computed: {
        showInTrialInfo() {
            return this.user.in_trial && !this.showSubscriptionCancelled && !this.showSubscriptionCancelledAndEffective;
        },

        showTrialExpiredInfo() {
            return this.user.trial_started
                && !this.user.in_trial
                && !this.user.subscription_active
                && !this.showSubscriptionCancelled
                && !this.showSubscriptionCancelledAndEffective
            ;
        },

        showPastDueWarning() {
            return this.user.subscription_past_due;
        },

        showSubscriptionCancelled() {
            return this.user.subscription_cancelled && !this.user.subscription_cancellation_is_effective;
        },

        showSubscriptionCancelledAndEffective() {
            return this.user.subscription_cancellation_is_effective;
        },

        showSuccessMessage() {
            return this.successMessage && !this.showSubscriptionCancelled && !this.showSubscriptionCancelledAndEffective;
        },

        hasActivePlan() {
            return this.user.active_plan_paddle_id !== null;
        },
    },
}
</script>
